import Vue from 'vue'
/**
 * 
 */
const has = Vue.directive('has', {
  inserted: function (el, binding, vnode) {
    // 获取页面按钮权限
    let btnPermissionsArr = [];
    if (binding.value) {
      // 如果指令传值，获取指令参数，根据指令参数和当前登录人按钮权限做比较。
      btnPermissionsArr = binding.value;
    } else {
      // 否则获取路由中的参数，根据路由的btnPermissionsArr和当前登录人按钮权限做比较。
      btnPermissionsArr = vnode.context.$route.meta.btnPermissions;
    }
    if (!Vue.prototype.$_has(btnPermissionsArr)) {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
});
// 权限检查方法
Vue.prototype.$_has = function (value) {
  let isExist = false;
  // 获取用户按钮权限
  let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
  if (btnPermissionsStr == undefined || btnPermissionsStr == null || btnPermissionsStr == "null") {
    return false;
  }
  let newBtnPermissionsStr = JSON.parse(btnPermissionsStr);
  if (newBtnPermissionsStr.findIndex((item) => {
    return item.id == value;
  }) > -1) {
    isExist = true;
  }
  return isExist;
};
export { has }


// WEBPACK FOOTER //
// ./src/utile/btnPermissions.js